import * as Actions from '../../../../redux/actions'

import {
    CalendarDuotoneIcon,
    PlaneArrivalIcon,
    PlaneDepartureIcon,
    TimesIcon,
} from "../SVGBank"
import moment from 'moment'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import DatePicker from "react-datepicker"
import React from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { getAirportsListThunk } from '../../FlightsPage/services/Flights.thunks'
import { getIPFromAmazon } from '../../HotelPage/hotelServices'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faArrowRightArrowLeft, faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { getDates, getFlightsByDate } from '../../FlightsPage/services/flights.services'
import { environment } from '../../../../Environments/environment'
import { useMediaQuery, useTheme } from '@material-ui/core'

const FlightFormFlightElement_ = ({ flight, flipDirection, flights, index, multiDestination, setFlightsData, removeAddedFlight, lengthFlights, is_mobile, lang, error, }) => {

    const dispatch = useDispatch()
    const useEmbedded = environment?.production ? false : true
    const airportsList = useSelector(state => state.Flights.airportsList)
    const [departureDate, setDepartureDate] = React.useState(flight.departureDate)
    let [searching, setSearching] = React.useState(false)
    let [cachedPrices, setCachedPrices] = React.useState()
    const [airportFrom, setAirportFrom] = React.useState(flight.airportFrom)
    const [airportTo, setAirportTo] = React.useState(flight.airportTo)
    const currency = useSelector(state => state.Setting.currency);
    const cabinClass = useSelector(state => state.Flights.flightData.cabinClass);
    const flightMode = useSelector(state => state.Flights.flightData.flightMode);
    const numberAdult = useSelector(state => state.Flights.flightData.numberAdult);
    const numberChild = useSelector(state => state.Flights.flightData.numberChild);
    const flightsList = useSelector(state => state.Flights.flightData.flights);
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down("xs"));

    const previous = multiDestination && flights?.length > 0 ? flights?.[index - 1] : null;

    const priceCache = React.useRef(new Map());

    const debounce = (fn, delay = 300) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn(...args), delay);
        };
    };

    const handleSelectedAirportsFrom = (airports) => {
        if (airports !== undefined) {
            setCachedPrices([])//clear cached prices
            priceCache.current.clear() // clear the price cache ref
            setAirportFrom(airports.length > 0 ? airports[0] : null)
            setFlightsData(flight, airports.length > 0 ? airports[0] : null, airportTo, departureDate)
        }
    }

    const handleSelectedAirportsTo = (airports) => {
        if (airports !== undefined) {
            setCachedPrices([])//clear cached prices
            priceCache.current.clear() // clear the price cache ref
            setAirportTo(airports.length > 0 ? airports[0] : null)
            setFlightsData(flight, airportFrom, airports.length > 0 ? airports[0] : null, departureDate)
        }
    }

    const handleChangeDepartureDate = (date) => {
        setDepartureDate(date)
        setFlightsData(flight, airportFrom, airportTo, date)
        fetchPricesWithProgress(date);
    }

    const handleSearchAirports = (query) => {
        dispatch(getAirportsListThunk(query))
    }

    React.useState(() => {
        if (flight?.departureDate) {
            setDepartureDate(flight.departureDate)
        }
    }, [flight])


    React.useEffect(() => {
        if (lengthFlights === 1) {
            const getAddress = async () => {
                const airport = await getIPFromAmazon();
                if (airport && !airportFrom) { //airportFrom not set
                    setAirportFrom(airport)
                    setFlightsData(flight, airport, airportTo, departureDate)
                }
            }
            getAddress()
        }
        if (lengthFlights > 1) {
            const multiDestinationFrom = multiDestination && flights?.length > 0 && index > 0 ? flights[index - 1]?.airportTo : null;
            if (multiDestination && multiDestinationFrom) {
                setAirportFrom(multiDestinationFrom)
                setFlightsData(flight, multiDestinationFrom, airportTo, departureDate)
            }
        }

    }, [lengthFlights])

    const fetchPricesWithProgress = async (baseDate) => {
        const dataToBookingFlights = {
            flightMode,
            cabinClass,
            numberAdult,
            numberChild,
            flights: flightsList,
            currency: fullCurrency
        }

        const dateRange = getDates(
            moment(baseDate).subtract(7, "days"),
            moment(baseDate).add(30, "days")
        );

        for (const date of dateRange) {
            const formatted = moment(date).format("YYYY-MM-DD");
            if (priceCache.current.has(formatted)) continue;

            const payload = {
                ...dataToBookingFlights,
                flights: [
                    { ...dataToBookingFlights?.flights?.[0], departureDateFormat: formatted },
                    { ...dataToBookingFlights?.flights?.[1], departureDateFormat: formatted }
                ],
                dateFormat: formatted
            };

            try {
                const data = await getFlightsByDate(payload);
                const price = data?.itinerary_data?.[0]?.price_details?.display_total_fare;

                if (price != null) {
                    priceCache.current.set(formatted, price);
                    setCachedPrices((prev) => [...(prev || []), { date: formatted, price }]);
                }
            } catch (e) {
                console.error(`Error loading price for ${formatted}`, e);
            }
        }
    }
    const renderDayContents = React.useCallback((day, date) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        const price = priceCache.current.get(formattedDate);
        let priceColor = "#ccc";

        if (cachedPrices?.length > 0 && price != null) {
            const sorted = [...cachedPrices].sort((a, b) => a.price - b.price);
            const top15 = sorted.slice(-15).map(p => p.date);
            const midStart = Math.floor((sorted.length - 15) / 2);
            const mid15 = sorted.slice(midStart, midStart + 15).map(p => p.date);
            const bottom15 = sorted.slice(0, 15).map(p => p.date);

            if (top15.includes(formattedDate)) priceColor = `var(--mainRed)`;
            else if (bottom15.includes(formattedDate)) priceColor = `var(--mainGreen)`;
            else if (mid15.includes(formattedDate)) priceColor = `var(--mainOrange)`;
        }

        return (
            <div>
                {price && !is_mobile && useEmbedded ? (
                    <div style={{
                        textAlign: "right",
                        padding: 5,
                        borderRadius: 10,
                        borderBottom: `10px solid ${priceColor}`,
                    }}>
                        <div>{day}</div>
                        <div style={{ font: "Futura Md BT" }}>
                            {currency?.selected?.symbol || "$"}{price}
                        </div>
                    </div>
                ) : (
                    <div style={{
                        padding: 5,
                        borderRadius: 10,
                        borderBottom: `10px solid transparent`,
                        textAlign: "right"
                    }}>
                        <div>{day}</div>
                        <div style={{ visibility: "hidden" }}>placeholder</div>
                    </div>
                )}
            </div>
        );
    }, [cachedPrices, is_mobile, useEmbedded, currency]);



    return (
        <div className={`${useEmbedded ? `embeddedDates` : ''} row m-0 w-100 mt-3 flightRoundTripForm`} style={{ padding: "1px", border: airportFrom !== null && airportTo !== null && airportFrom.iata === airportTo.iata ? "1px solid red" : "" }}>
            <div className="col-12 col-md-5 p-0">
                {lengthFlights > 1 && <div
                    style={{
                        cursor: "pointer",
                        position: "absolute",
                        zIndex: "1",
                        top: "18px",
                        left: "-20px",
                    }}
                    onClick={() => removeAddedFlight(flight)}><TimesIcon width={'15'} height={'15'} />
                </div>}
                <div className="position-relative fromAirport" style={{ border: airportFrom === null && error ? "1px solid red" : "" }}>
                    <AsyncTypeahead
                        id="flight-airport-from-typeahead"
                        labelKey={(option) => {
                            return (option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                `${option.iata} - ${option.airport}`)
                        }}
                        onChange={(e) => handleSelectedAirportsFrom(e)}
                        options={airportsList}
                        placeholder="From"
                        filterBy={() => true}
                        shouldSelect={true}
                        minLength={1}
                        onSearch={query => handleSearchAirports(query)}
                        renderMenuItemChildren={(option) => {
                            return (<div key={option.id} user={option} style={{
                                font: option.type === "main" ? "16px/30px Futura Md BT" : "",
                                paddingLeft: option.type === "sub" ? 20 : 0
                            }}>

                                {option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                    `${option.iata} - ${option.airport}`
                                }
                            </div>)
                        }}
                        selected={flight.airportFrom ? [flight.airportFrom] : []}
                        isLoading={false}
                        delay={100}
                        clearButton={is_mobile ? false : true}
                        multiple={false}
                    />
                    <div className="position-absolute" style={{ top: is_mobile ? "10px" : "14px", left: "7px" }}>
                        <PlaneDepartureIcon width={15} height={15} />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-5 p-0">

                <div className="position-relative toAirport" style={{ border: airportTo === null && error ? "1px solid red" : "" }}>
                    <AsyncTypeahead
                        id="light-airport-to-typeahead"
                        labelKey={(option) => {
                            return (option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                `${option.iata} - ${option.airport}`)
                        }}
                        onChange={(e) => handleSelectedAirportsTo(e)}
                        options={airportsList}
                        placeholder="To"
                        shouldSelect={true}
                        filterBy={() => true}
                        minLength={1}
                        onSearch={query => handleSearchAirports(query)}
                        renderMenuItemChildren={(option) => {
                            return (<div key={option.id} user={option} style={{
                                font: option.type === "main" ? "16px/30px Futura Md BT" : "",
                                paddingLeft: option.type === "sub" ? 20 : 0
                            }}>

                                {option.city ? `${option.city} (${option.iata} - ${option.airport})` :
                                    `${option.iata} - ${option.airport}`
                                }
                            </div>)
                        }}
                        selected={flight.airportTo ? [flight.airportTo] : []}
                        isLoading={false}
                        delay={100}
                        clearButton={is_mobile ? false : true}
                        multiple={false}
                    />


                    <div className="switchButton" style={{
                        position: 'absolute',
                        top: is_mobile ? "10px" : "14px",
                        left: is_mobile ? "-17px" : "-17px",
                        borderRadius: '50%',
                        width: is_mobile ? 30 : 35,
                        height: is_mobile ? 30 : 35,
                        background: 'white',
                        border: '1px solid #202020',
                        zIndex: 10,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }} onClick={() => { flipDirection(index) }}>

                        {smallScreen ? <div style={{ padding: 1, cursor: "pointer", textAlign: "center", display: 'flex', gap: 2 }}>
                            <FontAwesomeIcon icon={faArrowUp} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                            <FontAwesomeIcon icon={faArrowDown} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                        </div> :
                            <div style={{ padding: 1, cursor: "pointer", textAlign: "center" }}>
                                <FontAwesomeIcon icon={faArrowRightArrowLeft} style={{ color: '#202020', fontSize: is_mobile ? '12px' : '14px' }} />
                            </div>
                        }
                    </div>

                    <div className="position-absolute" style={{ top: is_mobile ? "10px" : "14px", left: "7px" }}>
                        <PlaneArrivalIcon width={15} height={15} />
                    </div>
                </div>
            </div>
            <div className="col-6 col-md-2 p-0">
                <div className="position-relative dateTo" style={{ border: departureDate === "" && error ? "1px solid red" : "" }}>
                    <DatePicker
                        selected={departureDate}
                        onChange={(date) => handleChangeDepartureDate(date)}
                        placeholderText="Departure"
                        dateFormat="yyyy/MM/dd"
                        // shouldCloseOnSelect={false}
                        renderDayContents={useEmbedded ? renderDayContents : null}
                        monthsShown={useEmbedded && !is_mobile ? 2 : 1}
                        showPopperArrow={false}
                        // minDate={flight.availableSelectDate}
                        minDate={multiDestination && previous ? new Date(moment(previous?.departureDateFormat)) : new Date()}
                        className="form-control" />
                    <div className="position-absolute" style={{ top: is_mobile ? "12px" : "14px", left: "7px" }}>
                        <CalendarDuotoneIcon width={15} height={15} />
                    </div>
                </div>
            </div>
        </div>

    )
}

const mapStateToProps = (state) => ({
    lang: state.Setting.lang,
    is_mobile: state.Setting.is_mobile,
    searchListAirports: state.Home.search_list_airports,
})

const mapDispatchToProps = {
    getAirportList: Actions.getAirportList,
}

const FlightFormFlightElement = connect(mapStateToProps, mapDispatchToProps)(FlightFormFlightElement_)
export default FlightFormFlightElement
